<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Civil Engineering'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/civil/faculty/karale_s_a.jpg`"
                   alt="Head of Department of Civil Engineering">
              <h3 class="text-lg font-bold text-gray-800 leading-tight">Prof. Karale.S.A</h3>
              <h4 class="text-gray-600 leading-tight">Head of the Department and Assistant Professor</h4>
            </div>
          </div>
          <blockquote class="mt-3 text-gray-600 text-justify font-medium">
            <p>Welcome to the Department of Civil Engineering., First I appreciate all the students who came from
              various geographic locations for showing their interest and admitted in the dept. of civil engineering.
              The Dept. of Civil Engineering, was started in the year 2011-12, with an intake of 60 seats. We are
              offering Post Graduation in Structural Engineering. specialization in the year 2013-14, with an intake
              of 24 seats.All the laboratories of the Dept. of Civil Engineering are well equipped with all the modern
              equipment and instruments.The Departmental Library is also having all the books of major subjects and
              competitive examinations preparation. All the facilities are highly qualified with M.E. Civil Engg. and
              pursuing Ph.D.We are having an effective teaching and learning scheme for the enhancement of students’
              knowledge by following the guidelines of Savitribai Phule Pune University.To get more practical
              knowledge we are organising various technical visits for the students, e.g. Koyana Dam, Sewage and Water
              Treatment Plant, RMC and Bituminous Hot Mix Plants, Structural Detailing and Smart city planning.
              Civil Engineering students have lots of career opportunities by either choosing MPSC examination for
              PWD, Irrigation,Water Resources Department.Structural and Project Managers at various infrastructure
              developments projects. Entrepreneurship by choosing Contractor, Builder, Developers, Estimators and
              valuers at various positions.One can also work at various municipal corporations by taking contracts.
              Regular Training and Placement activities are going on to place the students in the reputed organisation
              with a good salary package.</p>

            <signature name="Prof. Karale.S.A" designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}
</style>
